import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function authenReducer(state = initialState.authen, action) {
  switch (action.type) {
    case types.LOGOUT:
      return {};
    case types.AUTHENTICATION_SUCCESS:
      return {
        ...state,
        registeredUser: action.account,
      };
    case types.AUTHENTICATION_FAILED:
      return {
        ...state,
        registeredUser: action.account,
      };
    case types.LOGIN_SUCCESS:
      return {
        ...state,
        loggedInUser: action.account,
      };
    case types.LOGIN_FAILED:
      return {
        ...state,
        loggedInUser: action.account,
      };
    case types.MFA_REQUIRED:
      return {
        ...state,
        loggedInUser: {
          status: "MFA_REQUIRED",
          mfa_hash: action.account.mfa_hash,
          user_id: action.account.user_id,
          message: action.account.message || "MFA code sent to your email",
        },
      };

    case types.MFA_SUCCESS:
      return state;

    case types.MFA_FAILED:
      return {
        ...state,
        loggedInUser: {
          status: "MFA_FAILED",
          message: action.account.status || "Invalid MFA code",
        },
      };
    case types.ADMIN_SUCCESS:
      return {
        ...state,
        loggedInAdmin: action.account,
        accessToken: action.account.access,
        refreshToken: action.account.refresh,
      };
    case types.ADMIN_FAILED:
      return {
        ...state,
        loggedInAdmin: action.account,
      };
    case types.UPDATE_SECONDARY_ACCOUNT:
      return {
        ...state,
        loggedInUser: {
          ...state.loggedInUser,
          secondary_account: action.account,
          hassecondary: true,
        },
      };
    case types.DELETE_SECONDARY_ACCOUNT:
      return {
        ...state,
        loggedInUser: {
          ...state.loggedInUser,
          secondary_account: null,
          hassecondary: false,
        },
      };
    case types.UPDATE_ACCOUNT_VARIABLE:
      return {
        ...state,
        loggedInUser: {
          ...state.loggedInUser,
          ...action.account,
          variables: {
            ...state.loggedInUser.variables,
            ...(action.account.variables || {}),
          },
        },
      };
    default:
      return state;
  }
}

/*
All the logic for each feature is split across multiple files:
Action type constants
 * Action creators
 *Reducer switch/case
 * Async calls (thunks)

Redux Toolkit (RTK) merges all that logic into one place:

 Action types - auto-generated
 Action creators - auto-generated
 Reducers - written in object form instead of switch
 Async logic - handled by createAsyncThunk
 
*/

// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   registeredUser: null,
//   loggedInUser: null
// };

// const authenSlice = createSlice({
//   name: "authen",
//   initialState,
//   reducers: {
//     authenticationSuccess(state, action) {
//       state.registeredUser = action.payload;
//     },
//     loginSuccess(state, action) {
//       state.loggedInUser = action.payload;
//     }
//   }
// });

// export const { authenticationSuccess, loginSuccess } = authenSlice.actions;

// export default authenSlice.reducer;
